export default "__VITE_PUBLIC_ASSET__7354ffb9__"